import React from 'react';
import Image from '../image';
import starIcon from '../../../assets/images/xr/icons/star-icon.png';
import starFillIcon from '../../../assets/images/xr/icons/star-fill-icon.png';
import { ReactThreeFiber } from 'react-three-fiber';

type RatingProps = {
  value: number;

  position?: ReactThreeFiber.Vector3;
};

const maxRating = 5;
const ratingItems = new Array(maxRating).fill(0);

const Rating = ({ value, position }: RatingProps) => {
  const size = 0.02;

  return (
    <group position={position}>
      {ratingItems.map((_, index) => (
        <Image
          width={size}
          height={size}
          position={[(size + 0.01) * index, 0, 0]}
          src={index <= value ? starFillIcon : starIcon}
          key={index}
        />
      ))}
    </group>
  );
};

export default Rating;
